import { render, staticRenderFns } from "./MessagePushInfo.vue?vue&type=template&id=0c8e8165&"
import script from "./MessagePushInfo.vue?vue&type=script&lang=js&"
export * from "./MessagePushInfo.vue?vue&type=script&lang=js&"
import style0 from "./MessagePushInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports